import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Explore Top-Quality Roofing Solutions for Your Home"} subTitle={"Secure Your Home"} linear sideHeading />
        <Button link={"Get-Quote"} title={"Get Quote"} />

      </div>
    </section>
  );

};

export default Banner;